import { MODE } from '@/constants';

export const INITIALMODES = [
  {
    name: 'Drawing',
    icon: 'gesture',
    mode: MODE.DRAWING,
  },
  {
    name: 'Labels',
    icon: 'label_outline',
    mode: MODE.LABELS,
  },
  {
    name: 'Categories',
    icon: 'list',
    mode: MODE.CATEGORIES,
  },
  {
    name: 'Grouping',
    icon: 'group',
    mode: MODE.GROUP,
  },
  {
    name: 'POS',
    icon: 'store',
    mode: MODE.POS,
  },
  {
    name: 'Block',
    icon: 'lock_outline',
    mode: MODE.BLOCKSEATS,
  },
];

export const DIALOG = {
  title: 'Layout Chooser',
  contentHtml: 'All changes will be lost! Continue?',
  ok: 'OK',
  cancel: 'Cancel',
};

export const CANCELDIALOG = {
  title: 'Leaving the seatmap editor',
  contentHtml: "There are unsaved changes to the seatmap,<br /> Are you sure you'd like to discard them? <br />",
  ok: 'Save & Exit',
  cancel: 'Discard & Exit',
};

export const SAVEDIALOG = {
  title: 'Seatmap has errors',
  contentHtml: ' ',
  ok: 'OK',
  cancel: 'Cancel',
};
